<div [formGroup]="form">
    <div class="form-group">
        <div class="d-flex flex-row">
            <div class="d-flex align-items-center">
                <input type="checkbox" formControlName="isGuestAccount" />
            </div>
            <div class="d-flex align-items-center pl-2">
                {{ 'USERMANAGEMENT.MODAL_GUEST_ACCOUNT' | translate }}
            </div>
        </div>
    </div>
    <div class="d-flex flex-column w-100">
        <div class="form-group">
            <label for="gender">{{ 'USERMANAGEMENT.MODAL_TITLE' | translate }} *</label>
            <select class="form-control" id="gender" formControlName="gender">
                <option value="" selected>{{ 'CORE_CHOOSE_TITLE' | translate }}</option>
                <option value="FEMALE">{{ 'CORE_GENDER_FEMALE' | translate }}</option>
                <option value="MALE">{{ 'CORE_GENDER_MALE' | translate }}</option>
            </select>
            <div *ngIf="gender?.invalid && (gender?.dirty || gender?.touched)" class="text-danger pt-1">
                <div *ngIf="gender?.errors?.['required'] || gender?.errors?.['valueSelected']">{{ 'VALIDATION_ANGUCOMPLETE_REQUIRED' | translate }}</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="firstName">{{ 'USERMANAGEMENT.TABLE_HEADING_FIRST_NAME' | translate }} *</label>
                    <input type="text" class="form-control" id="firstName" placeholder="{{ 'USERMANAGEMENT.TABLE_HEADING_FIRST_NAME' | translate }}" formControlName="firstName" />
                    <div *ngIf="firstName?.invalid && (firstName?.dirty || firstName?.touched)" class="text-danger pt-1">
                        <div *ngIf="firstName?.errors?.['required']">{{ 'VALIDATION_REQUIRED' | translate }}</div>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="lastName">{{ 'USERMANAGEMENT.TABLE_HEADING_LAST_NAME' | translate }} *</label>
                    <input type="text" class="form-control" id="lastName" placeholder="{{ 'USERMANAGEMENT.TABLE_HEADING_LAST_NAME' | translate }}" formControlName="lastName" />
                    <div *ngIf="lastName?.invalid && (lastName?.dirty || lastName?.touched)" class="text-danger pt-1">
                        <div *ngIf="lastName?.errors?.['required']">{{ 'VALIDATION_REQUIRED' | translate }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6" *ngIf="!isGuestAccount?.value">
                <div class="form-group">
                    <label for="username">{{ 'USERMANAGEMENT.TABLE_HEADING_USERNAME' | translate }} *</label>
                    <input type="text" class="form-control" id="username" placeholder="{{ 'USERMANAGEMENT.TABLE_HEADING_USERNAME' | translate }}" formControlName="userName" />
                    <div *ngIf="userName?.invalid && (userName?.dirty || userName?.touched)" class="text-danger pt-1">
                        <div *ngIf="userName?.errors?.['required']">{{ 'VALIDATION_REQUIRED' | translate }}</div>
                        <div *ngIf="userName?.errors?.['userNameExists']">{{ userName?.errors?.['userNameExists'] }}</div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label for="email">E-Mail *</label>
                    <input type="email" class="form-control" id="email" placeholder="E-Mail" formControlName="email" />
                    <div *ngIf="email?.invalid && (email?.dirty || email?.touched)" class="text-danger pt-1">
                        <div *ngIf="email?.errors?.['required']">{{ 'VALIDATION_REQUIRED' | translate }}</div>
                        <div *ngIf="email?.errors?.['email']">{{ 'VALIDATION_EMAIL' | translate }}</div>
                        <div *ngIf="email?.errors?.['emailExists']">{{ email?.errors?.['emailExists'] }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex flex-column mb-2" *ngIf="!isGuestAccount?.value">
            <div class="mb-2">{{ 'AUTHENTICATION.PASSWORD' | translate }} *</div>
            <div *ngIf="editUser" class="form-group">
                <div class="d-flex flex-row">
                    <div class="d-flex align-items-center">
                        <input type="checkbox" formControlName="changePassword" />
                    </div>
                    <div class="d-flex align-items-center pl-2">
                        {{ 'USERMANAGEMENT.MODAL_CHANGE_PASSWORD' | translate }}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-10">
                    <input type="password" class="form-control" id="password" placeholder="{{ 'AUTHENTICATION.PASSWORD' | translate }}" formControlName="password" />
                    <div *ngIf="password?.invalid && (password?.dirty || password?.touched)" class="text-danger pt-1">
                        <div *ngIf="password?.errors?.['required']">{{ 'VALIDATION_REQUIRED' | translate }}</div>
                    </div>
                    <app-password-strength inputFormControlName="password"></app-password-strength>
                </div>
                <div class="col-2">
                    <button [disabled]="!this.changePassword?.value" type="button" class="align-self-end btn btn-primary edit-password" (click)="generatePassword()">
                        {{ 'USERMANAGEMENT.MODAL_GENERATE_PASSWORD' | translate }}
                    </button>
                </div>
            </div>
        </div>
        <div class="d-flex flex-column mb-3">
            <div class="d-flex flex-row mb-2 justify-content-between">
                <span>
                    {{ 'USERMANAGEMENT.TABLE_HEADING_ROLES' | translate }}
                </span>
                <div>
                    <i class="pi pi-info-circle mr-1" style="font-size: 13px"></i>
                    <a class="collapsed" data-toggle="collapse" href="#roleInfo" role="button"
                        >{{ 'USERMANAGEMENT.ROLE_INFO_TITLE' | translate }}<i class="ml-1 align-middle pi pi-angle-left"></i
                    ></a>
                </div>
            </div>
            <div class="collapse" id="roleInfo">
                <div class="mb-2" style="color: #676a6c">
                    {{ 'USERMANAGEMENT.ROLE_INFO' | translate }}
                </div>
            </div>
            <div class="role-multiselect">
                <p-multiSelect
                    id="roles"
                    [options]="(rolesOptions$ | async) || []"
                    formControlName="roles"
                    placeholder="{{ 'USERMANAGEMENT.TABLE_HEADING_ROLES' | translate }}"
                    [filter]="false"
                >
                    <ng-template let-role pTemplate="item">
                        <div>{{ translateRole(role) }}</div>
                    </ng-template>
                    <ng-template let-selectedItems pTemplate="selectedItems">
                        <div>{{ buildSelectedItemKey(selectedItems) }}</div>
                    </ng-template>
                </p-multiSelect>
            </div>
        </div>
        <div class="form-group" *ngIf="!isGuestAccount?.value">
            <div class="d-flex flex-row">
                <div class="d-flex align-items-center">
                    <input type="checkbox" formControlName="notifyUser" />
                </div>
                <div class="d-flex align-items-center pl-2">
                    {{ 'USERMANAGEMENT.MODAL_NOTIFY_USER' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
